import React, { Component } from "react";
import PropTypes from "prop-types";
// import { connect } from "react-redux";
import {
  Sidebar,
  Menu,
  MenuItemLink,
  getResources,
  Authenticated,
  // changeLocale as changeLocaleAction,
} from "react-admin";
// import { MenuItem } from "@mui/material/MenuItem";
import { withStyles } from "@mui/styles";
// import Divider from '@mui/material/Divider';
import { useLocation, withRouter } from "react-router-dom";
// import ListSubheader from '@mui/material/ListSubheader';
import List from "@mui/material/List";
import ListItem from "@mui/material/ListItem";
// import ListItemIcon from '@mui/material/ListItemIcon';
import ListItemText from "@mui/material/ListItemText";
import Collapse from "@mui/material/Collapse";
// import InboxIcon from '@mui/icons-material/MoveToInbox';
// import DraftsIcon from '@mui/icons-material/Drafts';
// import SendIcon from '@mui/icons-material/Send';
import ExpandLess from "@mui/icons-material/ExpandLess";
import ExpandMore from "@mui/icons-material/ExpandMore";
// import StarBorder from '@mui/icons-material/StarBorder';
import { Scrollbars } from "react-custom-scrollbars";
import {
  Dashboard as DashboardIcon,
  AccountCircle as AccountIcon,
  SettingsCell as OrderIcon,
  Person as PersonIcon,
  Loyalty as LoyaltyIcon,
} from "@mui/icons-material";
import DiscountIcon from "@mui/icons-material/Discount";
import NotificationsIcon from "@mui/icons-material/Notifications";
import MessageIcon from "@mui/icons-material/Message";
import ReceiptIcon from "@mui/icons-material/Receipt";
import ViewCarouselIcon from "@mui/icons-material/ViewCarousel";
import ProductImageIcon from "@mui/icons-material/Image";
import ContactSupportIcon from "@mui/icons-material/ContactSupport";
import RedeemIcon from "@mui/icons-material/Redeem";
import StarIcon from "@mui/icons-material/Star";
import PaymentIcon from "@mui/icons-material/Payment";
import DownloadIcon from "@mui/icons-material/Download";
// import SettingsIcon from '@mui/icons-material/icons/Settings';

import {
  GetCurrentUserRoles,
  getLocalStorageKey,
  RUN_TIME_API_ENDPOINT,
  CommonHeaderOption,
  loginType,
} from "./common/common";
// import environmentVariables from './utils/get-environment-variables';
import {
  gapi,
  loadAuth2,
  loadAuth2WithProps,
  loadClientAuth2,
} from "gapi-script";
import environmentVariables from "./globs/utils/get-environment-variables";

const googleClientID = "" + process.env.REACT_APP_GOOGLE_CLIENT_ID + "";
const styles = {
  root: {}, // Style applied to the MenuItem from material-ui
  active: { fontWeight: "bold" }, // Style applied when the menu item is the active one
  icon: {}, // Style applied to the icon
};

class MyMenu extends Component {
  static propTypes = {
    classes: PropTypes.any,
    resources: PropTypes.any,
    onMenuClick: PropTypes.any,
    logout: PropTypes.any,
  };
  state = {
    tempDisable: true,
    umOpen: false,
    aOpen: false,
    uOpen: false,
    dsOpen: false,
    lpOpen: false,
    pdfOpen: false,
    proofOpen: false,
    bashBanner: false,
    prodImg: false,
    pOpen: false,
    slOpen: false,
    scOpen: false,
    omOpen: false,
    proofStatus: false,
    dashBannerStatus: false,
    salesOfficersStatus: false,
    whiteListUsers: false,
    settingListStatus: false,
    hideReceivedYesNoStatus: false,
    complaintStatus: false,
    isnotifOpen: false,
    soNotifOpen: false,
    tcOpen: false,
    pmOpen: false,
    svOpen: false,
    smOpen: false,
    soSmOpen: false,
    pbpOpen: false,
    menuSettings: {
      config: false,
      admin: false,
      users: false,
      discount_schemes: false,
      loyaltyPoints: false,
      product: false,
      sales_order: false,
      schemes: false,
      other: false,
      daily_report: true,
      proof_of_payment: false,
      dashboard_banners: false,
      emailer_banners: false,
      dashboard_banners_web: false,
      productsmaster: false,
      sales_officers: false,
      whitelist_user: false,
      setting: false,
      termsNcond: false,
      registeredUsers: false,
      termConditionId: 1,
      promotionNotificationId: 1,
      isSalesOfficerPresent: false,
      notification: true,
      marketing: true,
      promotion: true,
      survey: true,
      priceUpdate: false,
      orderBlock: false,
    },
    language_id: 0,
    is_uae_sms_del: false,
  };

  componentDidMount() {
    const userLocale = getLocalStorageKey("locale");

    const stateData = localStorage.getItem('__state');
    const userData = stateData ? JSON.parse(stateData) : false;
    console.log("stateDataReceived", userData)

    const proofStatus = getLocalStorageKey("proof_of_payment");
    const dashBannerStatus = getLocalStorageKey("dashboard_banners");
    const dashBannerWebStatus = getLocalStorageKey("dashboard_banners_web");
    const productsMasterStatus = getLocalStorageKey("productsmaster");
    const hideReceivedYesNoStatus = getLocalStorageKey("hide_received_yes_no");
    const complaintStatus = getLocalStorageKey("complaint_mgmt");
    const salesOfficersStatus = getLocalStorageKey("sales_officers");
    const settingListStatus = getLocalStorageKey("setting_list");
    const whiteListUsers = getLocalStorageKey("whitelist_user");
    const targetUpload = getLocalStorageKey("target_upload");
    const loyaltyPointsList = getLocalStorageKey("loyalty_points");
    const isSalesOfficerPresent = getLocalStorageKey(
      "is_sales_off_app_present"
    );
    const paymentList = getLocalStorageKey("payment_list");
    const is_uae_sms_del = getLocalStorageKey("opco")?.country_id === 13;
    this.setState({ termConditionId: getLocalStorageKey("term_condition_id") });
    this.setState({
      promotionNotificationId: getLocalStorageKey("promotion_notification_id"),
    });
    const term_and_conditionsdata = getLocalStorageKey("term_condition_data");
    if (term_and_conditionsdata && term_and_conditionsdata.length > 0) {
      this.setState({ language_id: term_and_conditionsdata[0].id });
    }
    if (proofStatus) {
      this.setState({
        proofStatus: proofStatus,
      });
    }
    if (userData) {
      this.setState({
        showCustomerDownloads: userData?.admin_customer_downloads || false
      })
    }

    if (dashBannerStatus) {
      this.setState({
        dashBannerStatus: dashBannerStatus,
      });
    }
    if (productsMasterStatus) {
      this.setState({
        productsMasterStatus: productsMasterStatus,
      });
    }
    if (salesOfficersStatus) {
      this.setState({
        salesOfficersStatus: salesOfficersStatus,
      });
    }
    if (whiteListUsers) {
      this.setState({
        whiteListUsers: whiteListUsers,
      });
    }
    if (settingListStatus) {
      this.setState({
        settingListStatus: settingListStatus,
      });
    }
    if (hideReceivedYesNoStatus) {
      this.setState({
        hideReceivedYesNoStatus: hideReceivedYesNoStatus,
      });
    }
    if (complaintStatus) {
      this.setState({
        complaintStatus: complaintStatus,
      });
    }
    if (targetUpload) {
      this.setState({
        targetUpload,
      });
    }
    if (loyaltyPointsList) {
      this.setState({
        loyaltyPointsList,
      });
    }
    if (paymentList) {
      this.setState({
        paymentList,
      });
    }
    if (userLocale) {
      // this.props.changeLocale(userLocale);
    }
    if (isSalesOfficerPresent) {
      this.setState({
        isSalesOfficerPresent,
      });
    }
    if (is_uae_sms_del) {
      this.setState({
        is_uae_sms_del,
      });
    }
    const { props } = this;
    const currPath = props?.location?.pathname;

    this.setMenu(currPath)
    this.setRoleWiseMenu();
  }

  setMenu = (currPath = '') => {
    let menuObj = {
      umOpen: false,
      uOpen: false,
      aOpen: false,
      dsOpen: false,
      pdfOpen: false,
      pOpen: false,
      slOpen: false,
      proofOpen: false,
      emailerBanner: false,
      bashBanner: false,
      prodImg: false,
      cmangOpen: false,
      scOpen: false,
      omOpen: false,
      rpOpen: false,
      isnotifOpen: false,
      smOpen: false,
      soSmOpen: false,
      pmOpen: false,
      lpOpen: false,
      svOpen: false,
      pbpOpen: false
    };

    if (
      currPath.startsWith("/branches") ||
      currPath.startsWith("/subbranch") ||
      currPath.startsWith("/opcos")
    ) {
      menuObj["umOpen"] = true;
    } else if (
      currPath.startsWith("/whitelist_users") ||
      currPath.startsWith("/sales_officers") ||
      currPath.startsWith("/settings") ||
      currPath.startsWith("/madagascar_products_list") ||
      currPath.startsWith("/order_block_create") ||
      currPath.startsWith("/clickit_signup_customers") ||
      currPath.startsWith("/sap_contracts_product_list") ||
      currPath.startsWith("/payment_intents") ||
      currPath.startsWith("/delivery_tickets") ||
      currPath.startsWith("/terms_and_condition_list")
    ) {
      menuObj["aOpen"] = true;
    } else if (
      currPath.startsWith("/businesses") ||
      currPath.startsWith("/sap_contracts") ||
      currPath.startsWith("/sap_business_sites") ||
      currPath.startsWith("/users") ||
      currPath.startsWith("/sms_delivery_reports") ||
      currPath.startsWith("/business_targets")
    ) {
      menuObj["uOpen"] = true;
    } else if (
      currPath.startsWith("/discount_schemes")
    ) {
      menuObj["dsOpen"] = true;
    } else if (
      // currPath.startsWith("/productsmaster") ||
      currPath.startsWith("/prodmasteropbrmap") ||
      currPath.startsWith("/product")
    ) {
      menuObj["pOpen"] = true;
    } else if (
      currPath.startsWith("/customer_file_downloads")
    ) {
      menuObj["pdfOpen"] = true;
    } else if (
      currPath.startsWith("/sap_digital_app_orders") ||
      currPath.startsWith("/sap_digital_disputed_orders") ||
      currPath.startsWith("/received_digital_orders")
    ) {
      menuObj["slOpen"] = true;
    } else if (
      currPath.startsWith("/proof_of_payments")
    ) {
      menuObj["proofOpen"] = true;
    } else if (
      currPath.startsWith("/emailer_banners")
    ) {
      menuObj["emailerBanner"] = true;
    } else if (
      currPath.startsWith("/dashboard_banners") ||
      currPath.startsWith("/dashboard_banners_web")
    ) {
      menuObj["bashBanner"] = true;
    } else if (
      currPath.startsWith("/productsmaster")
    ) {
      menuObj["prodImg"] = true;
    } else if (
      currPath.startsWith("/complaints")
    ) {
      menuObj["cmangOpen"] = true;
    } else if (
      currPath.startsWith("/loyaltys") ||
      currPath.startsWith("/scheme") ||
      currPath.startsWith("/tagtoschememap") ||
      currPath.startsWith("/dashbanner")
    ) {
      menuObj["scOpen"] = true;
    } else if (
      currPath.startsWith("/tag") ||
      currPath.startsWith("/language") ||
      currPath.startsWith("/cntrylangmap")
    ) {
      menuObj["omOpen"] = true;
    } else if (
      currPath.startsWith("/activity_reports") ||
      currPath.startsWith("/ordering_reports") ||
      currPath.startsWith("/logins_reports") ||
      currPath.startsWith("/orders_reports")
    ) {
      menuObj["rpOpen"] = true;
    } else if (
      currPath.startsWith("/in_app_notifications") ||
      currPath.startsWith("/send_bulk_notifications") ||
      currPath.startsWith("/so_in_app_notifications")
    ) {
      menuObj["isnotifOpen"] = true;
    } else if (
      currPath.startsWith("/sms_blasts") ||
      currPath.startsWith("/send_sms_bulk_notifications")
    ) {
      menuObj["smOpen"] = true;
    } else if (
      currPath.startsWith("/so_sms_blasts")
    ) {
      menuObj["soSmOpen"] = true;
    } else if (
      currPath.startsWith("/promotions")
    ) {
      menuObj["pmOpen"] = true;
    } else if (
      currPath.startsWith("/loyalty_points")
    ) {
      menuObj["lpOpen"] = true;
    } else if (
      currPath.startsWith("/surveys")
    ) {
      menuObj["svOpen"] = true;
    } else if (
      currPath.startsWith("/probase_payments")
    ) {
      menuObj["pbpOpen"] = true;
    }

    this.setState(menuObj);
  }

  componentDidUpdate(prevProps, prevState) {
    if (this.props.location?.pathname !== prevProps.location?.pathname) {
      const currPath = this.props?.location?.pathname;

      this.setMenu(currPath);
    }
  };


  async loggedInUserValidity() {
    console.log(
      "googleClientID inside loggedInUserValidity===>",
      googleClientID
    );
    const client_id = googleClientID;

    const initSigninV2 = () => {
      gapi.auth2
        .init({
          client_id: client_id,
        })
        .then((res) => {
          // now auth2 is fully initialized
          // console.log('auth2 init success', res);
          console.log("isSignedIn====>", res.isSignedIn.le); //now this always returns correctly
          if (!res.isSignedIn.le) {
            this.props.history.push({
              pathname: "/login",
            });
          }
        });
    };
    gapi.load("auth2", initSigninV2);
    // let auth2 = await loadAuth2(gapi, client_id);
  }

  setRoleWiseMenu = () => {
    const { state } = this;
    const isMadagascar = getLocalStorageKey("opco")?.id === 15;
    let roleData = GetCurrentUserRoles();
    const is_uae_user = getLocalStorageKey("opco")?.id === 13;
    let currMenuSett = state.menuSettings;

    if (roleData === false) {
      return false;
    }

    if (roleData.indexOf("$sa") > -1) {
      currMenuSett = {
        // config: true,
        users: true,
        discount_schemes: true,
        loyaltyPoints: true,
        // product: true,
        sales_order: true,
        // schemes: true,
        // other: true,
        // daily_report: true,
        survey: true,
        promotion: true,
        marketing: true,
        notification: true,
      };
    } else if (roleData.indexOf("$sdo") > -1) {
      if (is_uae_user) {
        this.setState({ complaintStatus: false });
        this.setState({ isSalesOfficerPresent: false });
        currMenuSett = {
          users: true,
          discount_schemes: true,
          sales_order: true,
          proof_of_payment: true,
          emailer_banners: true,
          dashboard_banners: true,
          dashboard_banners_web: true,
          productsmaster: true,
        };
      } else {
        currMenuSett = {
          config: false,
          sales_order: true,
          admin: false,
          users: true,
          discount_schemes: true,
          proof_of_payment: true,
          emailer_banners: true,
          dashboard_banners: true,
          dashboard_banners_web: true,
          productsmaster: true,
          survey: true,
          promotion: true,
          marketing: true,
          notification: true,
        };
      }
    } else if (roleData.indexOf("$ca") > -1) {
      if (is_uae_user) {
        this.setState({ complaintStatus: false });
      }
      currMenuSett = {
        config: false,
        admin: true,
        users: true,
        discount_schemes: true,
        product: false,
        sales_order: true,
        proof_of_payment: true,
        emailer_banners: true,
        dashboard_banners: true,
        dashboard_banners_web: true,
        productsmaster: true,
        sales_officers: true,
        whitelist_user: true,
        survey: true,
        promotion: true,
        marketing: true,
        notification: true,
      };
    } else if (roleData.indexOf("$cs") > -1) {
      currMenuSett = {
        config: false,
        sales_order: true,
        users: true,
        discount_schemes: true,
        survey: true,
        promotion: true,
        marketing: true,
        notification: true,
      };
    } else if (roleData.indexOf("$csa") > -1) {
      if (isMadagascar) {
        currMenuSett = {
          config: false,
          admin: true,
          users: true,
          discount_schemes: true,
          loyaltyPoints: true,
          product: false,
          sales_order: true,
          schemes: false,
          other: false,
          daily_report: false,
          proof_of_payment: true,
          emailer_banners: true,
          dashboard_banners: true,
          dashboard_banners_web: true,
          productsmaster: true,
          sales_officers: true,
          whitelist_user: true,
          setting: true,
          termsNcond: true,
          registeredUsers: true,
          priceUpdate: true,
          survey: true,
          promotion: true,
          marketing: true,
          notification: true,
          orderBlock: true,
        };
      } else {
        currMenuSett = {
          config: false,
          admin: true,
          users: true,
          discount_schemes: true,
          loyaltyPoints: true,
          product: false,
          sales_order: true,
          schemes: false,
          other: false,
          daily_report: false,
          proof_of_payment: true,
          emailer_banners: true,
          dashboard_banners: true,
          dashboard_banners_web: true,
          sales_officers: true,
          whitelist_user: true,
          setting: true,
          termsNcond: true,
          registeredUsers: true,
          survey: true,
          promotion: true,
          marketing: true,
          notification: true,
          orderBlock: true,
        };
      }
    } else if (roleData.indexOf("$oba") > -1) {
      currMenuSett = {
        config: false,
        users: false,
        discount_schemes: false,
        product: true,
        sales_order: true,
        schemes: true,
        other: true,
        daily_report: true,
        survey: true,
        promotion: true,
        marketing: true,
        notification: true,
      };
    } else if (roleData.indexOf("$ra") > -1) {
      currMenuSett = {
        config: false,
        users: false,
        discount_schemes: false,
        product: false,
        sales_order: false,
        schemes: false,
        other: false,
        daily_report: true,
        survey: true,
        promotion: true,
        marketing: true,
        notification: true,
      };
    } else if (roleData.indexOf("Internal Control") > -1) {
      this.setState({ isSalesOfficerPresent: false });
      currMenuSett = {
        users: true,
        discount_schemes: true,
        sales_order: true,
        daily_report: false,
        notification: false,
        marketing: false,
        promotion: false,
        survey: false,
      };
    } else if (roleData.indexOf("Marketing") > -1) {
      console.log("inside Marketing");
      this.setState({ complaintStatus: false });
      currMenuSett = {
        users: true,
        discount_schemes: true,
        sales_order: true,
        survey: true,
        promotion: true,
        marketing: true,
        notification: true,
      };
    } else {
      currMenuSett = {
        config: false,
        users: false,
        discount_schemes: false,
        product: false,
        sales_order: false,
        schemes: false,
        other: false,
        daily_report: false,
        survey: true,
        promotion: true,
        marketing: true,
        notification: true,
      };
    }
    this.setState({ menuSettings: currMenuSett });
  };

  handleClick = (keyName) => {
    let menuObj = {};
    menuObj["umOpen"] = false;
    menuObj["uOpen"] = false;
    menuObj["uOpen"] = false;
    menuObj["lpOpen"] = false;
    menuObj["proofOpen"] = false;
    menuObj["bashBanner"] = false;
    menuObj["emailerBanner"] = false;
    menuObj["prodImg"] = false;
    menuObj["aOpen"] = false;
    menuObj["pOpen"] = false;
    menuObj["slOpen"] = false;
    menuObj["scOpen"] = false;
    menuObj["omOpen"] = false;
    menuObj["rpOpen"] = false;
    menuObj["cmangOpen"] = false;
    menuObj["isnotifOpen"] = false;
    menuObj["soNotifOpen"] = false;
    menuObj["tcOpen"] = false;
    menuObj["smOpen"] = false;
    menuObj["pmOpen"] = false;
    menuObj["svOpen"] = false;
    menuObj["pbpOpen"] = false;
    menuObj["soSmOpen"] = false;
    menuObj["pdfOpen"] = false
    menuObj[`${keyName}`] = !this.state[`${keyName}`];
    this.setState(menuObj);
  };
  render() {
    const { state, props } = this;
    if (loginType !== "password_based") {
      // this.loggedInUserValidity();
    } else {
      console.log("Do not check for isSignedIn");
    }
    let locale = getLocalStorageKey("locale");
    // console.log('state.menuSettings', state.menuSettings);
    return (
      <Authenticated>
        <Sidebar>
          <Menu className={"nv-menu"}>
            <MenuItemLink
              leftIcon={<DashboardIcon />}
              key={"dashboard"}
              className={`nv-menu-single`}
              to={`/`}
              primaryText={"Dashboard"}
              onClick={props.onMenuClick}
            />
            {state.menuSettings.config && (
              <>
                <ListItem
                  button
                  onClick={() => {
                    this.handleClick("umOpen");
                  }}
                  className={"nv-menu-outer"}
                >
                  <ListItemText
                    inset
                    primary="Config"
                    className={"nv-menu-text"}
                  />
                  {state.umOpen ? <ExpandLess /> : <ExpandMore />}
                </ListItem>
                <Collapse in={state.umOpen}>
                  <List className={"nv-menu-inner"}>
                    <MenuItemLink
                      key={"branches"}
                      classes={props.classes}
                      to={`/branches`}
                      primaryText={"Branches Master"}
                      onClick={props.onMenuClick}
                    />
                    <MenuItemLink
                      key={"subbranch"}
                      classes={props.classes}
                      to={`/subbranch`}
                      primaryText={"Sub Branches Master"}
                      onClick={props.onMenuClick}
                    />
                    <MenuItemLink
                      key={"opcos"}
                      classes={props.classes}
                      to={`/opcos`}
                      primaryText={"Opcos Master"}
                      onClick={props.onMenuClick}
                    />
                  </List>
                </Collapse>
              </>
            )}
            {state.menuSettings.admin &&
              (state.whiteListUsers ||
                state.salesOfficersStatus ||
                state.settingListStatus) && (
                // ( state.menuSettings.sales_officers || state.menuSettings.setting || state.menuSettings.whitelist_user ) &&
                <>
                  <ListItem
                    button
                    onClick={() => {
                      this.handleClick("aOpen");
                    }}
                    className={"nv-menu-outer"}
                  >
                    {" "}
                    {<PersonIcon />}
                    <ListItemText
                      inset
                      primary="Admin"
                      className={"nv-menu-text"}
                    />
                    {state.aOpen ? <ExpandLess /> : <ExpandMore />}
                  </ListItem>
                  <Collapse in={state.aOpen}>
                    <List className={"nv-menu-inner"}>
                      {state.whiteListUsers &&
                        state.menuSettings.whitelist_user && (
                          <MenuItemLink
                            key={"whitelist_users"}
                            classes={props.classes}
                            to={`/whitelist_users`}
                            primaryText={"Whitelist Users"}
                            onClick={props.onMenuClick}
                          />
                        )}
                      {state.salesOfficersStatus &&
                        state.menuSettings.sales_officers &&
                        state.isSalesOfficerPresent && (
                          <MenuItemLink
                            key={"sales_officers"}
                            classes={props.classes}
                            to={`/sales_officers`}
                            primaryText={"Sales Officers"}
                            onClick={props.onMenuClick}
                          />
                        )}
                      {state.settingListStatus &&
                        state.menuSettings.setting && (
                          <MenuItemLink
                            key={"settings"}
                            classes={props.classes}
                            to={`/settings`}
                            primaryText={"Settings"}
                            onClick={props.onMenuClick}
                          />
                        )}
                      {state.menuSettings.termsNcond && (
                        <MenuItemLink
                          key={"terms_and_condition_list"}
                          classes={props.classes}
                          to={`/terms_and_condition_list`}
                          primaryText={"Terms & Conditions"}
                          onClick={props.onMenuClick}
                        />
                      )}
                      {state.menuSettings.priceUpdate && (
                        <MenuItemLink
                          key={"madagascar_products_list"}
                          classes={props.classes}
                          to={`/madagascar_products_list`}
                          primaryText={"Price Update"}
                          onClick={props.onMenuClick}
                        />
                      )}
                      {state.menuSettings.orderBlock && (
                        <MenuItemLink
                          key={"order_block_create"}
                          classes={props.classes}
                          to={`/order_block_create`}
                          primaryText={"Ordering Blocked"}
                          onClick={props.onMenuClick}
                        />
                      )}
                      {locale == "en-PH" && (
                        <MenuItemLink
                          key={"clickit_signup_customers"}
                          classes={props.classes}
                          to={`/clickit_signup_customers`}
                          primaryText={"Registered Users"}
                          onClick={props.onMenuClick}
                        />
                      )}
                      {/* {state.menuSettings.termsNcond &&
                        <MenuItemLink key={'term_and_conditions'} classes={props.classes} to={`/term_and_conditions`} primaryText={'Terms & Conditions'} onClick={props.onMenuClick} />
                      } */}

                      <MenuItemLink
                        key={"sap_contracts_product_list"}
                        classes={props.classes}
                        to={`/sap_contracts_product_list`}
                        primaryText={"Product List"}
                        onClick={props.onMenuClick}
                      />
                      {locale == "ar-EG" && (
                        <MenuItemLink
                          key={"payment_intents"}
                          classes={props.classes}
                          to={`/payment_intents`}
                          primaryText={"Payments"}
                          onClick={props.onMenuClick}
                        />
                      )}
                      {locale == "en-UG" && (
                        <MenuItemLink
                          key={"delivery_tickets"}
                          classes={props.classes}
                          to={`/delivery_tickets`}
                          primaryText={"Delivery Tickets"}
                          onClick={props.onMenuClick}
                        />
                      )}
                    </List>
                  </Collapse>
                </>
              )}

            {state.menuSettings.users && (
              <>
                <ListItem
                  button
                  onClick={() => {
                    this.handleClick("uOpen");
                  }}
                  className={"nv-menu-outer"}
                >
                  {" "}
                  {<AccountIcon />}
                  <ListItemText
                    inset
                    primary="Users"
                    className={"nv-menu-text"}
                  />
                  {state.uOpen ? <ExpandLess /> : <ExpandMore />}
                </ListItem>
                <Collapse in={state.uOpen}>
                  <List className={"nv-menu-inner"}>
                    {/* <MenuItemLink  key={'whitelist_users'} classes={props.classes} to={`/whitelist_users`} primaryText={'Whitelist Users'} onClick={props.onMenuClick} /> */}
                    <MenuItemLink
                      key={"businesses"}
                      classes={props.classes}
                      to={`/businesses`}
                      primaryText={"Sold Tos"}
                      onClick={props.onMenuClick}
                    />
                    <MenuItemLink
                      key={"sap_contracts"}
                      classes={props.classes}
                      to={`/sap_contracts`}
                      primaryText={"Contracts"}
                      onClick={props.onMenuClick}
                    />
                    <MenuItemLink
                      key={"sap_business_sites"}
                      classes={props.classes}
                      to={`/sap_business_sites`}
                      primaryText={"Ship Tos"}
                      onClick={props.onMenuClick}
                    />
                    <MenuItemLink
                      key={"users"}
                      classes={props.classes}
                      to={`/users`}
                      primaryText={"Users"}
                      onClick={props.onMenuClick}
                    />
                    {state.is_uae_sms_del && (
                      <MenuItemLink
                        key={"sms_delivery_reports"}
                        classes={props.classes}
                        to={{
                          pathname: "/sms_delivery_reports",
                          search: `filter=${JSON.stringify({
                            country_id: 13,
                          })}`,
                        }}
                        primaryText={"SMS Deliveries"}
                        onClick={props.onMenuClick}
                      />
                    )}

                    {state.targetUpload && (
                      <div>
                        <MenuItemLink
                          key={"business_targets"}
                          classes={props.classes}
                          to={`/business_targets`}
                          primaryText={"Targets"}
                          onClick={props.onMenuClick}
                        />
                      </div>
                    )}
                  </List>
                </Collapse>
              </>
            )}

            {this.state.showCustomerDownloads && (
              <>
                <ListItem
                  button
                  onClick={() => {
                    this.handleClick("pdfOpen");
                  }}
                  className={"nv-menu-outer"}
                >
                  {" "}
                  {<DownloadIcon />}
                  <ListItemText
                    inset
                    primary="Customer Download"
                    className={"nv-menu-text"}
                  />
                  {state.pdfOpen ? <ExpandLess /> : <ExpandMore />}
                </ListItem>
                <Collapse in={state.pdfOpen}>
                  <List className={"nv-menu-inner"}>
                    <MenuItemLink
                      key={"uploadPDF"}
                      classes={props.classes}
                      to={`/customer_file_downloads`}
                      primaryText={"Customer Download List"}
                      onClick={props.onMenuClick}
                    />
                  </List>
                </Collapse>
              </>
            )}

            {state.menuSettings.discount_schemes && locale == "en-PH" && (
              <>
                <ListItem
                  button
                  onClick={() => {
                    this.handleClick("dsOpen");
                  }}
                  className={"nv-menu-outer"}
                >
                  {" "}
                  {<DiscountIcon />}
                  <ListItemText
                    inset
                    primary="Coupons"
                    className={"nv-menu-text"}
                  />
                  {state.dsOpen ? <ExpandLess /> : <ExpandMore />}
                </ListItem>
                <Collapse in={state.dsOpen}>
                  <List className={"nv-menu-inner"}>
                    <MenuItemLink
                      key={"discount_schemes"}
                      classes={props.classes}
                      to={`/discount_schemes`}
                      primaryText={"Scheme List"}
                      onClick={props.onMenuClick}
                    />
                  </List>
                </Collapse>
              </>
            )}
            {state.menuSettings.product && (
              <>
                <ListItem
                  button
                  onClick={() => {
                    this.handleClick("pOpen");
                  }}
                  className={"nv-menu-outer"}
                >
                  <ListItemText
                    inset
                    primary="Product"
                    className={"nv-menu-text"}
                  />
                  {state.pOpen ? <ExpandLess /> : <ExpandMore />}
                </ListItem>
                <Collapse in={state.pOpen}>
                  <List className={"nv-menu-inner"}>
                    <MenuItemLink
                      key={"productsmaster"}
                      classes={props.classes}
                      to={`/productsmaster`}
                      primaryText={"Product Master"}
                      onClick={props.onMenuClick}
                    />
                    <MenuItemLink
                      key={"prodmasteropbrmap"}
                      classes={props.classes}
                      to={`/prodmasteropbrmap`}
                      primaryText={"Products Master For Opco & Branch Mappings"}
                      onClick={props.onMenuClick}
                    />
                    <MenuItemLink
                      key={"product"}
                      classes={props.classes}
                      to={`/product`}
                      primaryText={"Product Retailer Mapping"}
                      onClick={props.onMenuClick}
                    />
                  </List>
                </Collapse>
              </>
            )}
            {state.menuSettings.sales_order && (
              <>
                <ListItem
                  button
                  onClick={() => {
                    this.handleClick("slOpen");
                  }}
                  className={"nv-menu-outer"}
                >
                  {" "}
                  {<OrderIcon />}
                  <ListItemText
                    inset
                    primary="Digital Order"
                    className={"nv-menu-text"}
                  />
                  {state.slOpen ? <ExpandLess /> : <ExpandMore />}
                </ListItem>
                <Collapse in={state.slOpen}>
                  <List className={"nv-menu-inner"}>
                    {/* <MenuItemLink  key={'sales'} classes={props.classes} to={`/sales`} primaryText={'Sales'} onClick={props.onMenuClick} />
                  <MenuItemLink  key={'customer_payments'} classes={props.classes} to={`/customer_payments`} primaryText={'Customer Payments'} onClick={props.onMenuClick} /> */}
                    <MenuItemLink
                      key={"sap_digital_app_orders"}
                      classes={props.classes}
                      to={`/sap_digital_app_orders`}
                      // primaryText={"Digital Orders via app"}
                      primaryText={"Digital Orders"}
                      onClick={props.onMenuClick}
                    />
                    {getLocalStorageKey("show_all_orders") && (
                      <MenuItemLink
                        key={"sap_digital_orders"}
                        classes={props.classes}
                        to={`/sap_digital_app_orders`}
                        primaryText={"Digital Orders"}
                        onClick={props.onMenuClick}
                      />
                    )}
                    {!state.hideReceivedYesNoStatus && (
                      <div>
                        <MenuItemLink
                          key={"sap_digital_disputed_orders"}
                          classes={props.classes}
                          to={`/sap_digital_disputed_orders`}
                          primaryText={"Disputed Digital Orders"}
                          onClick={props.onMenuClick}
                        />
                        <MenuItemLink
                          key={"received_digital_orders"}
                          classes={props.classes}
                          to={`/received_digital_orders`}
                          primaryText={"Received Digital Orders"}
                          onClick={props.onMenuClick}
                        />
                      </div>
                    )}
                    {/* <MenuItemLink key={'digital_order_transactions'} classes={props.classes} to={`/digital_order_transactions`} primaryText={'Digital Order Transactions'} onClick={props.onMenuClick} /> */}
                    {/* {
                    DigitalOrderSystem() ==== 'isManual' &&
                      <MenuItemLink key={'sap_sdo_for_orders'} classes={props.classes} to={`/sap_sdo_for_orders`} primaryText={'Digital Orders SDs'} onClick={props.onMenuClick} />
                  } */}
                  </List>
                </Collapse>
              </>
            )}
            {state.menuSettings.proof_of_payment && state.proofStatus && (
              <>
                <ListItem
                  button
                  onClick={() => {
                    this.handleClick("proofOpen");
                  }}
                  className={"nv-menu-outer"}
                >
                  {" "}
                  {<ReceiptIcon />}
                  <ListItemText
                    inset
                    primary="Proof of Payment"
                    className={"nv-menu-text"}
                  />
                  {state.proofOpen ? <ExpandLess /> : <ExpandMore />}
                </ListItem>
                <Collapse in={state.proofOpen}>
                  <List className={"nv-menu-inner"}>
                    <MenuItemLink
                      key={"proof_of_payments"}
                      classes={props.classes}
                      to={`/proof_of_payments`}
                      primaryText={"Proof Records"}
                      onClick={props.onMenuClick}
                    />
                  </List>
                </Collapse>
              </>
            )}
            {
              // state.menuSettings.dashboard_banners && state.dashBannerStatus &&
              <>
                <ListItem
                  button
                  onClick={() => {
                    this.handleClick("emailerBanner");
                  }}
                  className={"nv-menu-outer"}
                >
                  {" "}
                  {<ViewCarouselIcon />}
                  <ListItemText
                    inset
                    primary="Emailer Banner"
                    className={"nv-menu-text"}
                  />
                  {state.emailerBanner ? <ExpandLess /> : <ExpandMore />}
                </ListItem>
                <Collapse in={state.emailerBanner}>
                  <List className={"nv-menu-inner"}>
                    <MenuItemLink
                      key={"emailer_banners"}
                      classes={props.classes}
                      to={`/emailer_banners`}
                      primaryText={"Emailer Banner list"}
                      onClick={props.onMenuClick}
                    />
                  </List>
                </Collapse>
              </>
            }
            {
              // state.menuSettings.dashboard_banners && state.dashBannerStatus &&
              <>
                <ListItem
                  button
                  onClick={() => {
                    this.handleClick("bashBanner");
                  }}
                  className={"nv-menu-outer"}
                >
                  {" "}
                  {<ViewCarouselIcon />}
                  <ListItemText
                    inset
                    primary="Home Banner"
                    className={"nv-menu-text"}
                  />
                  {state.bashBanner ? <ExpandLess /> : <ExpandMore />}
                </ListItem>
                <Collapse in={state.bashBanner}>
                  <List className={"nv-menu-inner"}>
                    <MenuItemLink
                      key={"dashboard_banners"}
                      classes={props.classes}
                      to={`/dashboard_banners`}
                      primaryText={"Mobile Banner list"}
                      onClick={props.onMenuClick}
                    />
                    <MenuItemLink
                      key={"dashboard_banners_web"}
                      classes={props.classes}
                      to={`/dashboard_banners_web`}
                      primaryText={"Web banner list"}
                      onClick={props.onMenuClick}
                    />
                  </List>
                </Collapse>
              </>
            }
            {
              // state.menuSettings.productsmaster && state.productsMasterStatus &&
              <>
                <ListItem
                  button
                  onClick={() => {
                    this.handleClick("prodImg");
                  }}
                  className={"nv-menu-outer"}
                >
                  {" "}
                  {<ProductImageIcon />}
                  <ListItemText
                    inset
                    primary="Product Image"
                    className={"nv-menu-text"}
                  />
                  {state.prodImg ? <ExpandLess /> : <ExpandMore />}
                </ListItem>
                <Collapse in={state.prodImg}>
                  <List className={"nv-menu-inner"}>
                    <MenuItemLink
                      key={"productsmaster"}
                      classes={props.classes}
                      to={`/productsmaster`}
                      primaryText={"Product Image list"}
                      onClick={props.onMenuClick}
                    />
                  </List>
                </Collapse>
              </>
            }
            {state.complaintStatus && (
              <>
                <ListItem
                  button
                  onClick={() => {
                    this.handleClick("cmangOpen");
                  }}
                  className={"nv-menu-outer"}
                >
                  {" "}
                  {<ContactSupportIcon />}
                  <ListItemText
                    inset
                    primary="Contact Us"
                    className={"nv-menu-text"}
                  />
                  {state.cmangOpen ? <ExpandLess /> : <ExpandMore />}
                </ListItem>
                <Collapse in={state.cmangOpen}>
                  <List className={"nv-menu-inner"}>
                    <MenuItemLink
                      key={"Contact Us"}
                      classes={props.classes}
                      to={`/complaints`}
                      primaryText={"Contact Us"}
                      onClick={props.onMenuClick}
                    />
                  </List>
                </Collapse>
              </>
            )}

            {state.menuSettings.schemes && (
              <>
                <ListItem
                  button
                  onClick={() => {
                    this.handleClick("scOpen");
                  }}
                  className={"nv-menu-outer"}
                >
                  <ListItemText
                    inset
                    primary="Schemes"
                    className={"nv-menu-text"}
                  />
                  {state.scOpen ? <ExpandLess /> : <ExpandMore />}
                </ListItem>
                <Collapse in={state.scOpen}>
                  <List className={"nv-menu-inner"}>
                    <MenuItemLink
                      key={"loyaltys"}
                      classes={props.classes}
                      to={`/loyaltys`}
                      primaryText={"Loyalties"}
                      onClick={props.onMenuClick}
                    />
                    <MenuItemLink
                      key={"scheme"}
                      classes={props.classes}
                      to={`/scheme`}
                      primaryText={"Schemes"}
                      onClick={props.onMenuClick}
                    />
                    <MenuItemLink
                      key={"tagtoschememap"}
                      classes={props.classes}
                      to={`/tagtoschememap`}
                      primaryText={"Tag to Scheme Mappings"}
                      onClick={props.onMenuClick}
                    />
                    <MenuItemLink
                      key={"dashbanner"}
                      classes={props.classes}
                      to={`/dashbanner`}
                      primaryText={"Dashboard Banners"}
                      onClick={props.onMenuClick}
                    />
                  </List>
                </Collapse>
              </>
            )}
            {state.menuSettings.other && (
              <>
                <ListItem
                  button
                  onClick={() => {
                    this.handleClick("omOpen");
                  }}
                  className={"nv-menu-outer"}
                >
                  <ListItemText
                    inset
                    primary="Other Master"
                    className={"nv-menu-text"}
                  />
                  {state.omOpen ? <ExpandLess /> : <ExpandMore />}
                </ListItem>
                <Collapse in={state.omOpen}>
                  <List className={"nv-menu-inner"}>
                    <MenuItemLink
                      key={"tag"}
                      classes={props.classes}
                      to={`/tag`}
                      primaryText={"Tag"}
                      onClick={props.onMenuClick}
                    />
                    <MenuItemLink
                      key={"language"}
                      classes={props.classes}
                      to={`/language`}
                      primaryText={"Languages"}
                      onClick={props.onMenuClick}
                    />
                    <MenuItemLink
                      key={"cntrylangmap"}
                      classes={props.classes}
                      to={`/cntrylangmap`}
                      primaryText={"Country Language Mappings"}
                      onClick={props.onMenuClick}
                    />
                  </List>
                </Collapse>
              </>
            )}
            {state.menuSettings.daily_report && (
              <>
                <ListItem
                  button
                  onClick={() => {
                    this.handleClick("rpOpen");
                  }}
                  className={"nv-menu-outer"}
                >
                  <ListItemText
                    inset
                    primary="Daily Reports"
                    className={"nv-menu-text"}
                  />
                  {state.rpOpen ? <ExpandLess /> : <ExpandMore />}
                </ListItem>
                <Collapse in={state.rpOpen}>
                  <List className={"nv-menu-inner"}>
                    <MenuItemLink
                      key={"activity_reports"}
                      classes={props.classes}
                      to={`/activity_reports`}
                      primaryText={"Activity Report"}
                      onClick={props.onMenuClick}
                    />
                    <MenuItemLink
                      key={"ordering_reports"}
                      classes={props.classes}
                      to={`/ordering_reports`}
                      primaryText={"Ordering Report"}
                      onClick={props.onMenuClick}
                    />
                    <MenuItemLink
                      key={"logins_reports"}
                      classes={props.classes}
                      to={`/logins_reports`}
                      primaryText={"Logins Report"}
                      onClick={props.onMenuClick}
                    />
                    <MenuItemLink
                      key={"orders_reports"}
                      classes={props.classes}
                      to={`/orders_reports`}
                      primaryText={"Orders Report"}
                      onClick={props.onMenuClick}
                    />
                  </List>
                </Collapse>
              </>
            )}
            {state.menuSettings.notification && (
              <>
                <ListItem
                  button
                  onClick={() => {
                    this.handleClick("isnotifOpen");
                  }}
                  className={"nv-menu-outer"}
                >
                  {" "}
                  {<NotificationsIcon />}
                  <ListItemText
                    inset
                    primary="Notification"
                    className={"nv-menu-text"}
                  />
                  {state.isnotifOpen ? <ExpandLess /> : <ExpandMore />}
                </ListItem>
                <Collapse in={state.isnotifOpen}>
                  <List className={"nv-menu-inner"}>
                    <MenuItemLink
                      key={"In_app_notifications"}
                      classes={props.classes}
                      to={`/in_app_notifications`}
                      primaryText={"In app messages"}
                      onClick={props.onMenuClick}
                    />
                    <MenuItemLink
                      key={"send_bulk_notifications"}
                      classes={props.classes}
                      to={`/send_bulk_notifications`}
                      primaryText={"Bulk in app messages"}
                      onClick={props.onMenuClick}
                    />
                    {state.isSalesOfficerPresent && (
                      <MenuItemLink
                        key={"so_in_app_notifications"}
                        classes={props.classes}
                        to={`/so_in_app_notifications`}
                        primaryText={"Sales Officer app messages"}
                        onClick={props.onMenuClick}
                      />
                    )}
                  </List>
                </Collapse>
              </>
            )}
            {state.menuSettings.marketing && (
              <>
                <ListItem
                  button
                  onClick={() => {
                    this.handleClick("smOpen");
                  }}
                  className={"nv-menu-outer"}
                >
                  {" "}
                  {<MessageIcon />}
                  <ListItemText
                    inset
                    primary="Marketing"
                    className={"nv-menu-text"}
                  />
                  {state.smOpen ? <ExpandLess /> : <ExpandMore />}
                </ListItem>
                <Collapse in={state.smOpen}>
                  <List className={"nv-menu-inner"}>
                    <MenuItemLink
                      key={"send_message"}
                      classes={props.classes}
                      to={`/sms_blasts`}
                      primaryText={"Send message"}
                      onClick={props.onMenuClick}
                    />
                    <MenuItemLink
                      key={"send_sms_bulk_notifications"}
                      classes={props.classes}
                      to={`/send_sms_bulk_notifications`}
                      primaryText={"Send bulk message"}
                      onClick={props.onMenuClick}
                    />
                  </List>
                </Collapse>
              </>
            )}

            {state.isSalesOfficerPresent && (
              <>
                <ListItem
                  button
                  onClick={() => {
                    this.handleClick("soSmOpen");
                  }}
                  className={"nv-menu-outer"}
                >
                  {" "}
                  {<MessageIcon />}
                  <ListItemText
                    inset
                    primary="Sales Officer Marketing"
                    className={"nv-menu-text"}
                  />
                  {state.soSmOpen ? <ExpandLess /> : <ExpandMore />}
                </ListItem>
                <Collapse in={state.soSmOpen}>
                  <List className={"nv-menu-inner"}>
                    <MenuItemLink
                      key={"send_message"}
                      classes={props.classes}
                      to={`/so_sms_blasts`}
                      primaryText={"Sales Officer Send message"}
                      onClick={props.onMenuClick}
                    />
                  </List>
                </Collapse>
              </>
            )}
            {state.menuSettings.promotion && (
              <>
                <ListItem
                  button
                  onClick={() => {
                    this.handleClick("pmOpen");
                  }}
                  className={"nv-menu-outer"}
                >
                  {" "}
                  {<RedeemIcon />}
                  <ListItemText
                    inset
                    primary="Promotion"
                    className={"nv-menu-text"}
                  />
                  {state.pmOpen ? <ExpandLess /> : <ExpandMore />}
                </ListItem>
                <Collapse in={state.pmOpen}>
                  <List className={"nv-menu-inner"}>
                    <MenuItemLink
                      key={"promotion_notifications"}
                      classes={props.classes}
                      to={`/promotions`}
                      primaryText={"Promotions"}
                      onClick={props.onMenuClick}
                    />
                  </List>
                </Collapse>
              </>
            )}
            {state.menuSettings.loyaltyPoints && state.loyaltyPointsList && (
              <>
                <ListItem
                  button
                  onClick={() => {
                    this.handleClick("lpOpen");
                  }}
                  className={"nv-menu-outer"}
                >
                  {" "}
                  {<LoyaltyIcon />}
                  <ListItemText
                    inset
                    primary="Loyalty Points"
                    className={"nv-menu-text"}
                  />
                  {state.lpOpen ? <ExpandLess /> : <ExpandMore />}
                </ListItem>
                <Collapse in={state.lpOpen}>
                  <List className={"nv-menu-inner"}>
                    <div>
                      <MenuItemLink
                        key={"loyalty_points"}
                        classes={props.classes}
                        to={`/loyalty_points`}
                        primaryText={"Loyalty Points List"}
                        onClick={props.onMenuClick}
                      />
                    </div>
                  </List>
                </Collapse>
              </>
            )}
            {state.menuSettings.survey && (
              <>
                <ListItem
                  button
                  onClick={() => {
                    this.handleClick("svOpen");
                  }}
                  className={"nv-menu-outer"}
                >
                  {" "}
                  {<StarIcon />}
                  <ListItemText
                    inset
                    primary="Survey"
                    className={"nv-menu-text"}
                  />
                  {state.svOpen ? <ExpandLess /> : <ExpandMore />}
                </ListItem>
                <Collapse in={state.svOpen}>
                  <List className={"nv-menu-inner"}>
                    <MenuItemLink
                      key={"survey"}
                      classes={props.classes}
                      to={`/surveys`}
                      primaryText={"Surveys"}
                      onClick={props.onMenuClick}
                    />
                  </List>
                </Collapse>
              </>
            )}
            {state.paymentList && (
              <>
                <ListItem
                  button
                  onClick={() => {
                    this.handleClick("pbpOpen");
                  }}
                  className={"nv-menu-outer"}
                >
                  {" "}
                  {<PaymentIcon />}
                  <ListItemText
                    inset
                    primary="Probase Payments"
                    className={"nv-menu-text"}
                  />
                  {state.pbpOpen ? <ExpandLess /> : <ExpandMore />}
                </ListItem>
                <Collapse in={state.pbpOpen}>
                  <List className={"nv-menu-inner"}>
                    <div>
                      <MenuItemLink
                        key={"probase_payments"}
                        classes={props.classes}
                        to={`/probase_payments`}
                        primaryText={"Probase Payment List"}
                        onClick={props.onMenuClick}
                      />
                    </div>
                  </List>
                </Collapse>
              </>
            )}
          </Menu>
        </Sidebar>
      </Authenticated>
    );
  }
}

// const mapStateToProps = (state) => ({
//   resources: getResources(state),
// });

// export default withRouter(
//   connect(mapStateToProps, { changeLocale: changeLocaleAction })(
//     withStyles(styles)(MyMenu)
//   )
// );

MyMenu.propTypes = {
  classes: PropTypes.any,
  resources: PropTypes.any,
  onMenuClick: PropTypes.any,
  logout: PropTypes.any,
};

const LocationWrapper = (WrappedComponent) => {
  const ComponentWithLocation = (props) => {
    const location = useLocation();
    return <WrappedComponent {...props} location={location} />;
  };

  return ComponentWithLocation;
};

export default LocationWrapper(MyMenu);